import slider1 from "~/assets/slide/a1.webp";
import slider2 from "~/assets/slide/a2.webp";
import slider3 from "~/assets/slide/a3.webp";
import slider4 from "~/assets/slide/a4.webp";
import slider5 from "~/assets/slide/a5.webp";
import slider6 from "~/assets/slide/a6.webp";
import slider7 from "~/assets/slide/a7.webp";
import slider8 from "~/assets/slide/a8.webp";
import slider9 from "~/assets/slide/a9.webp";
import slider10 from "~/assets/slide/a10.webp";
import slider11 from "~/assets/slide/a11.jpg";
import slider12 from "~/assets/slide/a12.jpg";
import slider13 from "~/assets/slide/a13.png";
import slider14 from "~/assets/slide/a14.jpg";


export const sliderListImage = [
    {
        id: 1,
        src: slider1,
    },
    {
        id: 2,
        src: slider2,
    },
    {
        id: 3,
        src: slider3,
    },
    {
        id: 4,
        src: slider4,
    },
    {
        id: 5,
        src: slider5,
    },
    {
        id: 6,
        src: slider6,
    },
    {
        id: 7,
        src: slider7,
    },
    {
        id: 8,
        src: slider8,
    },
    {
        id: 9,
        src: slider9,
    },
    {
        id: 10,
        src: slider10,
    },
    {
        id: 11,
        src: slider11,
    },
    {
        id: 12,
        src: slider12,
    },
    {
        id: 13,
        src: slider13,
    },
    {
        id: 14,
        src: slider14,
    },
]
